// extracted by mini-css-extract-plugin
export default {"innerWrapper":"xv-z","tooltipWrapper":"yv-z","icon":"zv-z","tooltip":"Av-z","content":"Bv-z"};